import RouteMeta from '@/router/constants/route-meta';
import RouteNames from '@/router/constants/route-names';

const UNAUTHORIZED_STATUS_CODE = 401;

const unauthenticatedErrorHandler = async (apiError, router, store) => {
  const isUnauthorizedError = apiError.status === UNAUTHORIZED_STATUS_CODE;
  const isRootRoute = router.currentRoute.path === '/';
  const isAccountManagementRoute = router.currentRoute.meta[RouteMeta.AccountManagementStep];

  // eject early
  if (!isUnauthorizedError) {
    return;
  }

  // reset user
  try {
    await store.dispatch('resetUser');
  } catch (err) {
    // eat the error
  }

  // redirect user
  if (!isRootRoute && !isAccountManagementRoute) {
    router.replace({
      name: RouteNames.AppointmentSignIn,
      params: {
        loggedOut: true,
        ...router.currentRoute.params,
      },
    });
  }
};

export default unauthenticatedErrorHandler;
